import React from "react";
import { Modal } from "antd";

export const PropertyDeveloperModalContentComponent = (props) => {
  const { visible, onOk, content = null } = props;

  return (
    <>
      <Modal
        title="View Project"
        visible={visible}
        onOk={onOk}
        onCancel={onOk}
        width="80%"
        centered={false}
        closable={true}
      >
        {content}
      </Modal>
    </>
  );
};
